import { fetch } from '@atlassian/eoc-fetch';

import { type SaveViewParams } from '../../../common/types';

export const saveViewEndpoint = (teamId: string, view: SaveViewParams) => {
	return fetch(`/v1/users/ui-preferences/teams/${teamId}/escalations`, {
		method: 'PATCH',
		body: view,
		responseType: 'headers',
	});
};

export const completeTaskEndpoint = async (teamId: string) => {
	await fetch('/v1/onboarding/complete-task', {
		method: 'POST',
		body: {
			platformTeamId: teamId,
			completedItemKey: 'opsgenie-review-oncall-setup',
		},
	});

	return fetch('/v1/onboarding/complete-task', {
		method: 'POST',
		body: {
			platformTeamId: teamId,
			completedItemKey: 'compass-oncall-setup',
		},
	});
};
